<template>
	<div class="play-video" :style="videoHeight">
		<div class="controlplay" @click="playVideo"></div>
		<video-player
			class="vjs-custom-skin"
			ref="videoPlayer"
			:options="playerOptions"
			webkit-playsinline
			playsinline
			x-webkit-airplay="allow"
			x5-video-player-type="h5"
			x5-video-player-fullscreen="true"
			x5-video-orientation="portraint"
			@pause="onPlayerPause($event)"
			@ended="onPlayerEnded($event)"
			@playing="onPlayerPlaying($event)"
			@ready="playerIsReady"
			@play="onPlay($event)"
		></video-player>
	</div>
</template>

<script>
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
export default {
	name: "customVideo",
	components: {
		videoPlayer,
	},
	props: {
		videoUrl: {
			type: String,
			default: () => "",
		},
		videoPoster: {
			type: String,
			default: () => "",
		},
		videoWidth: {
			type: Number,
			default: () => "",
		},
	},
	data() {
		return {
			videoHeight: 0,
			playerOptions: {
				controls: true,
				autoplay: false,
				muted: false,
				height: this.videoWidth,
				width: this.videoWidth,
				preload: "metadata",
				techOrder: ["html5"],
				sources: [
					{
						type: "video/mp4",
						src: this.videoUrl,
					},
				],
				poster: this.videoPoster,
			},
			playing: false,
		};
	},
	computed: {
		player() {
			return this.$refs.videoPlayer.player;
		},
	},
	methods: {
		resizeEvent() {
			this.videoHeight = this.$el.clientWidth;
		},
		playVideo() {
			if (this.playing) {
				this.playing = false;
				this.player.pause();
			} else {
				this.playing = true;
				this.player.play();
			}
		},
		onPlay() {
			console.log("onplay");
		},
		onPlayerPlaying() {
			console.log("playing");
		},
		onPlayerPause() {
			console.log("Pause");
		},
		onPlayerEnded() {
			console.log("onPlayerEnded");
		},
		playerIsReady() {
			console.log("playerIsReady");
		},
		playerStateChanged() {
			console.log("playerStateChanged");
		},
	},
	created() {},
	mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.play-video {
	position: relative;
	.controlplay {
		position: absolute;
		width: 100%;
		top: 0;
		bottom: 35px;
		z-index: 1;
	}
}
</style>
